<div class="page-content-wrapper">
  <section class="ids-container" id="microfrontend-wrapper">
    <mfe-alert></mfe-alert>
    <!-- <div *ngIf="isHome" class="microfrontend-row banner-container">
      <img src="assets/img/banner_cop.svg"
        alt="Banner informando sobre a Conferência das Partes" 
        aria-hidden="true"
        loading="eager"
        fetchpriority="high"
        decoding="sync"
        [style.display]="'block'"
        [style.max-width]="'100%'"
        [style.height]="'auto'">
    </div> -->
    <div class="microfrontend-row ids-row" *ngFor="let row of rowList">
      <div *ngFor="let item of row" class="ids-col-{{item.layout.cols}} microfrontend-item">
        <button class="accessibility-mfe-button" (focus)="selectMfeAndBecomeItAcessible($event)" tabindex="0">Aperte
          Enter para acessar o conteúdo de {{ item.descricao }}</button>
        <div class="ids-card" id="wrapper-{{item.tag_html}}-{{path}}">
          <ids-loading class="loader"
            *ngIf="!loadedReference[item.tag_html] && !errorReference[item.tag_html]"></ids-loading>
          <app-microfrontend-error [ngClass]="{'showError': errorReference[item.tag_html]}"></app-microfrontend-error>
        </div>
      </div>
    </div>
  </section>
</div>
